import React from 'react';
import { Link } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Red with a call to action when there is something to fix; a quiet
// "all clear" otherwise, so the strip never shouts about zero.
function AlertCard({ title, value, action, to, icon }) {
  const hasIssues = value > 0;

  if (!hasIssues) {
    return (
      <div className="h-full bg-white rounded-xl border border-gray-200 shadow-sm px-4 py-3 flex items-center gap-3">
        <CheckCircleOutlineIcon className="text-green-600" />
        <div>
          <p className="text-sm text-gray-900">{title}</p>
          <p className="text-xs text-gray-500">All clear</p>
        </div>
      </div>
    );
  }

  return (
    <Link
      to={to}
      className="group h-full bg-red-50 rounded-xl border border-red-200 px-4 py-3 flex items-center gap-3 hover:border-red-300 hover:shadow-sm transition"
    >
      <span className="text-red-600 flex">{icon}</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-red-900">{title}</p>
        <p className="text-xs text-red-700">{action}</p>
      </div>
      <span className="text-xl font-semibold text-red-700 tabular-nums">
        {value.toLocaleString()}
      </span>
      <ChevronRightIcon className="text-red-400 group-hover:translate-x-0.5 transition-transform" />
    </Link>
  );
}

export default AlertCard;
